import './Footer.css';
import wagerwizlogoname from '../../assets/WagerWiz_OnDark_Vector.svg';
import facebookicon from '../../assets/images/facebook_icon.svg';
import twittericon from '../../assets/images/twitter_icon.svg';
import linkedinicon from '../../assets/images/linkedin_icon.svg';
import instagramicon from '../../assets/images/instagram_icon.svg';
import { useEffect, useState } from 'react';

const DownloadPDF = (path, name) => {
	const handleDownload = () => {
		const link = document.createElement('a');
		link.href = path; // File in the public folder
		link.download = path; // Name it however you want
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return <button style={{textAlign: "left"}} onClick={handleDownload}>{name}</button>;
};

export const Footer = (props) => {
	const [width, setWidth] = useState(window.innerWidth);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);

	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			if (window.innerWidth >= 750) {
				setIsMobile(false);
			} else {
				setIsMobile(true);
			}
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return (
		<div style={{ backgroundColor: '#17191d', borderTop: '1px solid #363846', paddingTop: '20px', paddingBottom: '20px', width: '100%' }}>
			<div className="flex flex-row pt-4" style={{ justifyContent: 'center', paddingLeft: 115, paddingRight: 115 }}>
				{!isMobile && <img style={{ alignSelf: 'start', paddingTop: '10px', width: 250 }} src={wagerwizlogoname} alt="wagerwiz logo" />}
				<div style={{ display: 'grid', gridTemplateColumns: 'auto auto', marginLeft: 'auto', fontSize: '24px' }}>
					<nav className="flex flex-col" style={{ marginRight: '50px' }} aria-label="Pages">
						<div style={{ fontWeight: 'bolder' }}>Pages</div>
						<a href="/" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Home
						</a>
						<a href="/#features" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							About
						</a>
						<a
							href="mailto:support@thewagerwiz.com?subject=Contact&body=Contact%20-%20website"
							style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Contact
						</a>
					</nav>
					<nav className="flex flex-col" aria-label="Resources">
						<div style={{ fontWeight: 'bolder' }}>Resources</div>
						<a href="/pricing" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Pricing
						</a>
						<a href="/ev-scanner" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							EV Scanner
						</a>
						<a href="/screener" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Odds Screener
						</a>
						<a href="/tools" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Tools
						</a>
						<a href="/blog" style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer', textDecoration: 'none' }}>
							Blog
						</a>
						<div style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer' }}>{DownloadPDF('/Terms of Service.pdf', 'Terms & Conditions')}</div>
						<div style={{ color: '#b1b6c1', fontSize: '20px', cursor: 'pointer' }}>{DownloadPDF('/WagerWiz Privacy Policy.pdf', 'Privacy Policy')}</div>
					</nav>
					{/* Social media icons under navigation */}
					<div className="flex flex-row" style={{ gridColumn: '1 / span 2', marginTop: 24, justifyContent: 'center' }}>
						<div onClick={() => { window.open('https://x.com/wagerwizbet', '_blank') }} className="mr-6 cursor-pointer">
							<img src={twittericon} alt="twitter icon" style={{ width: 38, height: 38 }} />
						</div>
						<div onClick={() => { window.open('https://www.linkedin.com/company/wagerwiz/', '_blank') }} className="mr-6 cursor-pointer">
							<img src={linkedinicon} alt="linkedin icon" style={{ width: 38, height: 38 }} />
						</div>
						<div onClick={() => { window.open('https://www.instagram.com/wagerwiz_/', '_blank') }} className="cursor-pointer">
							<img src={instagramicon} alt="instagram icon" style={{ width: 38, height: 38 }} />
						</div>
					</div>
				</div>
			</div>
			<div className="mt-12" style={{ border: '1px solid #363844', marginLeft: 'auto', marginRight: 'auto' }} />
			<div className="mt-4" style={{fontSize: '18px', textAlign: 'center'}}>
				Copyright © 2025 | ValueBeaver, Inc.
			</div>
		</div>
	);
};
